export type SimpleEventAction =
  | 'user_info_update'
  | 'user_info_route_change_back'
  | 'user_info_route_change_confirm'
  | 'user_password_update'
  | 'user_password_route_change_confirm'
  | 'user_password_route_change_back'
  | 'send_solutions_magazine_update'
  | 'offers_by_email_update'
  | 'profiling_accepted_update'
  | 'addresses_item_update'
  | 'addresses_item_create'
  | 'addresses_item_delete'
  | 'request_partial_delivery_show'
  | 'partial_delivery_not_available_clicked'
  | 'partial_delivery_request'
  | 'related-product-shown-in-order-details'
  | 'contacts_item_delete'
  | 'order_list_search_field_used'
  | 'external_order_list_search_field_used'
  | 'view_empty_cart'
  | 'search_field_activated'

export type SimpleEventType = {
  event: SimpleEventAction
}

export type ContactsInviteType = {
  event: 'contact_item_invite'
  intvite_action: 'sent' | 'delete' | 'update'
}

export type DigitalDataAddressAction = 'create' | 'update' | 'change' | 'delete'
export type DigitalDataAddressEvent =
  | 'address_create'
  | 'address_update'
  | 'address_change'
  | 'address_delete'
export type DigitalDataAddressType = 'billing' | 'shipping'

export type AddressEventType = {
  event: DigitalDataAddressEvent
  address_type?: DigitalDataAddressType
}

export type OrderCancelDeniedReason = 'over 60 days' | 'only unopened'
export type OrderCancelDeniedType = {
  event: 'order_cancel_denied'
  reason: OrderCancelDeniedReason
}

export type RmaCaseReasonType =
  | 'damaged_in_transit'
  | 'defective_product'
  | 'incorrect_delivery'
  | 'missing_delivery'
  | 'missing_product'
  | 'none'
  | 'wrong_purchase'
  | 'wrong_specification'

export type RmaOrderItemType = {
  item_name: string
  item_id: string
}

export type RmaCreateCaseType = {
  event: 'rma_create_case'
  rma_create_case_reason: RmaCaseReasonType
  items: RmaOrderItemType[]
}

type EventInfoSelection = {
  selection: string
}
export type AccountLoginType = {
  event: 'login_initiated'
  event_info: EventInfoSelection
}

export type LoginUserType = {
  event: 'login_user'
  event_info: {
    userId: string
  }
}

export type CreateAccountStartHeaderType = {
  event: 'create_account_initiated_header'
}

export type CreateAccountStartFooterType = {
  event: 'create_account_initiated_footer'
}

export type CreateAccountStartCheckoutType = {
  event: 'create_account_initiated_checkout'
}

export type CreateAccountEmailType = {
  event: 'create_account_email'
}

export type CreateAccountCompanyType = {
  event: 'create_account_company'
}

export type CreateAccountCreateType = {
  event: 'create_account_create'
}

export type CreateAccountCompletedType = {
  event: 'create_account_completed'
}
export type GA4ViewPromotionEvent = GA4Event<GA4Promotion, 'view_promotion'>

export type GA4SelectPromotionEvent = GA4Event<GA4Promotion, 'select_promotion'>

export type GA4Event<ProductData, EventName> = {
  event: EventName
  ecommerce: ProductData
}

export type GA4CartProduct = GA4ItemCategories & {
  item_brand: string
  quantity?: number | null
  item_id: string
  price: number
  item_name: string
}

export type GA4Product = GA4ItemCategories & {
  item_list_name?: string
  index?: number
  item_name: string
  item_id: string
  price: string
  item_brand: string
  quantity?: number | null
  availability: string
  product_life_cycle?: string
  hasImage: boolean
  weighted_average_score?: string
  variant_count?: number
  has_variants?: boolean
  label?: string[] | null
  item_list_page: string
  add_to_cart_order?: number
  has_ai_description?: boolean
}

export type GA4ItemCategories = {
  item_category: string
  [key: `item_category${string}`]: string
}

export type GA4Promotion = {
  promotion_id: string
  promotion_name: string
  creative_name: string
  creative_slot: string
}

type GrantedOrDenied = 'granted' | 'denied'
export type ConsentUpdatedType = {
  event: 'consent_updated'
  ad_storage: GrantedOrDenied
  analytics_storage: GrantedOrDenied
  ad_personalization: GrantedOrDenied
  ad_user_data: GrantedOrDenied
}

export type NavigationInteractionType =
  | 'link_click'
  | 'open_menu'
  | 'close_menu'
  | 'dropdown_open'
  | 'dropdown_closed'

export type SearchShortcutInteractionType = 'link_click'
export type SearchShortcutTypes = 'latest_searches' | 'popular_searches'

export type SearchInteractionItemEventType = {
  event: 'click_search_dropdown'
}

export type SearchShortcutInteractionEventType = {
  event: 'autocomplete_search_dropdown_executed'
  event_info: {
    interaction: SearchShortcutInteractionType
    selection: string
    search_shortcut: SearchShortcutTypes
  }
}

export enum NavigationSelectionType {
  SoftCategory = 'soft-category',
  Category = 'category',
  CategoryEntrance = 'category_entrance',
  Services = 'services',
  Orders = 'orders',
}

export enum NavigationEventType {
  MainMenu = 'main_menu',
  CategoryMenu = 'category_menu',
}

export interface NavigationExtras {
  selectionType?: NavigationSelectionType
  disableSelectionSanitize?: boolean
}

export type NavigationItemEventType = {
  event: NavigationEventType
  event_info: {
    interaction: NavigationInteractionType
    selection: string
    selectionType?: NavigationSelectionType
  }
}

type FilterInteractionType = 'select_filter' | 'link_click'
type SortingInteractionType = 'select_sorting'
export type FacetClickEventType = {
  event: 'filter'
  event_info: {
    interaction: FilterInteractionType
    filter_category: string
  }
}
export type FilterCatClickEventType = {
  event: 'filter'
  event_info: {
    interaction: FilterInteractionType
    selection: string
  }
}
export type SortClickEventType = {
  event: 'sorting'
  event_info: {
    interaction: SortingInteractionType
    selection: string
  }
}
export type CatMenuItemClickEventType = {
  event: 'category_menu'
  event_info: {
    interaction: 'link_click'
    selection: string
  }
}

export type CartNotificationAction = 'go_to_cart' | 'go_to_accessories' | 'go_to_checkout'
